module.exports = __webpack_public_path__ + "18e8765a207d6a23337ce55a53e91dda.jpg";


//////////////////
// WEBPACK FOOTER
// ../assets/adamkrogh-photo.jpg
// module id = 509
// module chunks = 0